import styled, { css } from 'styled-components';

interface ActiveProps {
  active: boolean;
  titleColor?: string;
}

interface ActivePropsFavorite {
  activefav: boolean;
  shadow?: boolean;
  bloqued?: boolean;
}

export const Container = styled.div<{
  isFaq: boolean;
  isRegion1: boolean;
  isRegion2: boolean;
  isRegion3: boolean;
  isRegion4: boolean;
}>`
  width: 100%;
  padding-bottom: 25px;
  display: flex;

  .topicContainer {
    padding: 5px 13px;
    background: var(--orange);
    color: var(--white);
    border-radius: 10px;
    display: inline-flex !important;
    margin-top: 5px;
  }

  .regions {
    padding: 5px 13px;
    background: var(--orange);
    color: var(--white);
    border-radius: 10px;
    display: inline-flex !important;
    margin-top: 5px;
    margin-right: 5px;
    text-transform: uppercase;
  }

  ${props =>
    props.isFaq &&
    css`
      border: 1.5px solid #c2d1d9;
      border-radius: 2px;
      margin-bottom: 1em;
      margin-top: 5px;
    `}
`;

export const AccordionItem = styled.div<ActivePropsFavorite>`
  background: var(--white);
  width: 100%;
  padding: 1rem;
  border-radius: 20.5px;

  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: ${props => (props.shadow ? 'var(--box-shadow)' : 'inherit')};
  .buttonfav {
    text-align: right;
    margin-right: 3px;

    pointer-events: ${props => (props.bloqued ? 'none' : 'all')};

    button {
      width: 20px;
      background: transparent;
      font-size: 1.2rem;
      color: ${props => (props.activefav ? `var(--orange)` : `black`)};
    }
  }

  .icon-container {
    background-color: transparent;
    width: 100%;
    text-align: left;
  }
`;

export const InitialContainer = styled.div<ActiveProps>`
  display: flex;

  p {
    color: red !important;
  }

  .ball-container {
    margin-right: 15px;
    display: flex;
    align-items: flex-start;
    height: 100%;

    div {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background: var(--soft-orange);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .text-container {
    width: 100%;
    font-family: 'Source Sans Pro' !important;


    > div {
      display: flex;
      justify-content: space-between;
    }

    h1 {
      color: ${props =>
        props.titleColor ? `var(--${props.titleColor})` : 'var(--orange)'};

      font-size: 1.75rem;
      line-height: 1.7rem;
      @media (max-width: 685px) {
        font-size: 1.50rem;
      }
      @media (max-width: 578px) {
        font-size: 1.25rem;
      }
    }
    .subtitle-container {
      
  }

  button {
    color: var(--orange);
    transition: all 0.5s ease;
    cursor: pointer;
    background: transparent;
    height: 0;

    svg {

      ${props =>
        props.active &&
        css`
          transform: rotate(90deg);
        `}
    }
  }
`;

export const CollapseContainer = styled.div<ActiveProps>`
  transition: all 0.5s ease;
  margin-top: 20px;
  padding: 0 5px;
  min-height: 0;
  height: 0;
  transition: all 0.2s ease-out;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

  span {
    color: var(--title-higlight);
    font-style: normal;
    font-weight: normal;
    font-size: 1.1rem;
    line-height: 1.1rem;
  }

  ${props =>
    props.active &&
    css`
      min-height: 30px;
      height: auto;
      transition: all 0.25s ease-in;
    `}
`;
